/* JAYKEI "Pick Your Play": masked heading reveal on scroll-in. */
(function () {
  'use strict';
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init() {
    document.querySelectorAll('[data-jk-pick]').forEach(function (root) {
      if (root.dataset.intro === 'ready') return;
      if (reduced || !('IntersectionObserver' in window)) return;  // CSS leaves it visible
      root.dataset.intro = 'ready';
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-intro-in');
          io.unobserve(e.target);
        });
      }, { threshold: 0.2, rootMargin: '0px 0px -10% 0px' });
      io.observe(root);
    });
  }

  /* The mobile rail scrolls natively under a finger. A mouse gets nothing from
     overflow-x on its own, so grab-and-drag is wired up here - pointer events
     cover both, and touch is left alone so native momentum still applies. */
  function drag() {
    document.querySelectorAll('[data-jk-pick] .jk-pick__tray').forEach(function (tray) {
      if (tray.dataset.drag === 'on') return;
      tray.dataset.drag = 'on';
      var down = false, moved = false, startX = 0, startLeft = 0;

      tray.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return;          // native scrolling is better
        if (tray.scrollWidth <= tray.clientWidth) return;
        down = true; moved = false;
        startX = e.clientX;
        startLeft = tray.scrollLeft;
      });

      tray.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX;
        // a few px of slop, so a plain click still opens the product
        if (!moved && Math.abs(dx) < 4) return;
        if (!moved) { moved = true; tray.classList.add('is-dragging'); tray.setPointerCapture(e.pointerId); }
        tray.scrollLeft = startLeft - dx;
        e.preventDefault();
      });

      function end(e) {
        if (!down) return;
        down = false;
        if (moved) {
          tray.classList.remove('is-dragging');
          try { tray.releasePointerCapture(e.pointerId); } catch (err) {}
          // the click that follows the drag belongs to the drag, not the card
          tray.addEventListener('click', function swallow(ev) {
            ev.stopPropagation(); ev.preventDefault();
            tray.removeEventListener('click', swallow, true);
          }, true);
        }
      }
      tray.addEventListener('pointerup', end);
      tray.addEventListener('pointercancel', end);
      tray.addEventListener('dragstart', function (e) { if (moved) e.preventDefault(); });
    });
  }

  function boot() { init(); drag(); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
